"use client";

import { ConsentManagerImpl as $hgUW1$ConsentManagerImpl, NoopStore as $hgUW1$NoopStore, Config as $hgUW1$Config } from "@brynlabs/consent-core";
import { useContext as $hgUW1$useContext, createContext as $hgUW1$createContext, useRef as $hgUW1$useRef, useEffect as $hgUW1$useEffect, useState as $hgUW1$useState } from "react";
import { jsxs as $hgUW1$jsxs, jsx as $hgUW1$jsx, Fragment as $hgUW1$Fragment } from "react/jsx-runtime";
import { TranslationServiceImpl as $hgUW1$TranslationServiceImpl } from "@brynlabs/consent-core/dist/src/translation-service-impl";
const $e15a2bbaef6a9f12$export$7b28c394b609b819 = /*#__PURE__*/(0, $hgUW1$createContext)(new (0, $hgUW1$Config)({}));
const $e15a2bbaef6a9f12$export$fff3d94683fb820f = _ref => {
  let {
    children: children,
    config: config
  } = _ref;
  return /*#__PURE__*/(0, $hgUW1$jsxs)($e15a2bbaef6a9f12$export$7b28c394b609b819.Provider, {
    value: new (0, $hgUW1$Config)(config),
    children: [/*#__PURE__*/(0, $hgUW1$jsx)("script", {
      type: "text/javascript",
      dangerouslySetInnerHTML: {
        __html: "var brynConsentConfig = ".concat(JSON.stringify(config))
      }
    }), /*#__PURE__*/(0, $hgUW1$jsx)("script", {
      "data-bryn-consent-config": "brynConsentConfig",
      type: "application/javascript",
      src: "/bryn_consent.js"
    }), children]
  });
};
const $477f60ce67ff82c9$export$61957425aaf004ec = (key, defaultObject) => {
  const ref = (0, $hgUW1$useRef)(defaultObject);
  (0, $hgUW1$useEffect)(() => {
    const loadService = () => {
      const translationService = window[key];
      if (!translationService) {
        const timeout = setTimeout(() => loadService(), 50);
        return () => clearTimeout(timeout);
      } else ref.current = translationService;
      return () => {};
    };
    return loadService();
  }, []);
  return ref;
};
const $74148c3179b2fca2$export$ddf53f26a9d1c984 = () => {
  const config = (0, $hgUW1$useContext)((0, $e15a2bbaef6a9f12$export$7b28c394b609b819));
  return (0, $477f60ce67ff82c9$export$61957425aaf004ec)("brynConsent", new (0, $hgUW1$ConsentManagerImpl)(config, new (0, $hgUW1$NoopStore)()));
};
const $0313143ff4a12149$export$8510890de8a1e26f = () => {
  const config = (0, $hgUW1$useContext)((0, $e15a2bbaef6a9f12$export$7b28c394b609b819));
  return (0, $477f60ce67ff82c9$export$61957425aaf004ec)("brynConsentTranslationService", new (0, $hgUW1$TranslationServiceImpl)(config));
};
const $040a2e0afb4ff48d$export$9c4bb267f121099a = service => {
  const [consent, setConsent] = (0, $hgUW1$useState)(false);
  const manager = (0, $74148c3179b2fca2$export$ddf53f26a9d1c984)();
  (0, $hgUW1$useEffect)(() => {
    var _consentObservable$va;
    if (!(manager !== null && manager !== void 0 && manager.current)) return;
    const consentObservable = manager.current.observeConsent(service);
    setConsent((_consentObservable$va = consentObservable.value) !== null && _consentObservable$va !== void 0 ? _consentObservable$va : false);
    return consentObservable.subscribe(setConsent);
  }, [manager.current]);
  return {
    consent: consent,
    manager: manager
  };
};
const $bbfafa141a84c3b8$export$fae42920e1f2e75 = contextualConsent => {
  const [consent, setConsent] = (0, $hgUW1$useState)(false);
  const manager = (0, $74148c3179b2fca2$export$ddf53f26a9d1c984)();
  (0, $hgUW1$useEffect)(() => {
    var _consentObservable$va2;
    if (!(manager !== null && manager !== void 0 && manager.current)) return;
    const consentObservable = manager.current.observeContextualConsent(contextualConsent);
    setConsent((_consentObservable$va2 = consentObservable.value) !== null && _consentObservable$va2 !== void 0 ? _consentObservable$va2 : false);
    return consentObservable.subscribe(setConsent);
  }, [manager.current]);
  return {
    consent: consent,
    manager: manager
  };
};
function $81ac6578137e9db2$export$2f8b47a141e57afc(_ref2) {
  let {
    service: service,
    src: src,
    ...props
  } = _ref2;
  const {
    consent: consent
  } = (0, $040a2e0afb4ff48d$export$9c4bb267f121099a)(service);
  return /*#__PURE__*/(0, $hgUW1$jsx)((0, $hgUW1$Fragment), {
    children: /*#__PURE__*/(0, $hgUW1$jsx)("script", {
      async: true,
      ...props,
      src: consent ? src : undefined,
      type: "text/javascript"
    }, "consent-script-".concat(service))
  });
}
function $9af3eaae663d4ee1$export$bcd4b8b4f6a1d8be(_ref3) {
  let {
    contextualConsent: contextualConsent,
    children: children
  } = _ref3;
  const ref = (0, $hgUW1$useRef)(null);
  const {
    consent: consent
  } = (0, $bbfafa141a84c3b8$export$fae42920e1f2e75)(contextualConsent);
  const renderContextualConsent = (0, $477f60ce67ff82c9$export$61957425aaf004ec)("brynConsent_renderContextualConsent", () => () => {});
  (0, $hgUW1$useEffect)(() => {
    if (!consent && ref.current && renderContextualConsent.current) return renderContextualConsent.current(ref.current, contextualConsent, undefined);
    return () => {};
  }, [consent, ref, renderContextualConsent]);
  if (!consent) return /*#__PURE__*/(0, $hgUW1$jsx)("div", {
    ref: ref
  });
  return /*#__PURE__*/(0, $hgUW1$jsx)((0, $hgUW1$Fragment), {
    children: children
  });
}
export { $74148c3179b2fca2$export$ddf53f26a9d1c984 as useManager, $0313143ff4a12149$export$8510890de8a1e26f as useTranslationService, $040a2e0afb4ff48d$export$9c4bb267f121099a as useConsent, $bbfafa141a84c3b8$export$fae42920e1f2e75 as useContextualConsent, $e15a2bbaef6a9f12$export$fff3d94683fb820f as BrynConsentProvider, $81ac6578137e9db2$export$2f8b47a141e57afc as Script, $9af3eaae663d4ee1$export$bcd4b8b4f6a1d8be as ContextualConsent };